import { useTheme } from "@mui/material/styles";
import React from "react";

const CustomLabelLine = (props) => {
  const theme = useTheme();
  const { cx, cy, midAngle, outerRadius, fill, percent, totalValue, value } =
    props;
  const textValue = `${(percent * totalValue).toFixed(0)}`;

  const RADIAN = Math.PI / 180;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const mx = cx + (outerRadius + 20) * cos;
  const my = cy + (outerRadius + 20) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 30;
  const ey = my;
  const rectangleWidth = Math.max(34, String(textValue).length * 10);
  const rectangleHeight = 20;
  const borderRadius = 10;
  return (
    <g>
      <line
        x1={mx}
        y1={my}
        x2={ex}
        y2={ey}
        stroke={fill}
        strokeWidth={1}
        strokeDasharray="1,1"
      />
      <rect
        x={ex - rectangleWidth / 2}
        y={ey - rectangleHeight / 2}
        width={rectangleWidth}
        height={rectangleHeight}
        rx={borderRadius}
        ry={borderRadius}
        fill={theme.palette.grey[300]}
        stroke={fill}
        strokeWidth={1}
      />
      <text
        x={ex}
        y={ey}
        fontSize={12}
        textAnchor="middle"
        dominantBaseline="central"
      >
        {value}
      </text>
    </g>
  );
};

export default CustomLabelLine;
